var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    attrs: {
      id: "key-contact-modal",
      "modal-dialog-scrollable": false,
      "loaders-disabled": "",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("global.actions.emailSomeone", {
                    name: _vm.contactName,
                  })
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", { staticClass: "text-light-grey" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("account.keyContacts.anyProblemsEmailTo", {
                      email: _vm.contactEmail,
                    })
                  ) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "b-button",
              {
                attrs: {
                  variant: "primary",
                  tag: "a",
                  href: "mailto:" + _vm.contactEmail,
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("account.keyContacts.openOnEmailClient")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }